import fetch from './fetch';

const registerUser = (data, captchaResponse) => fetch('users', {
  headers: {
    'captcha-response': captchaResponse,
  },
  method: 'post',
  body: JSON.stringify(data),
});

export default registerUser;
